import { Injectable, inject } from '@angular/core';
import { Observable, map, of, shareReplay } from 'rxjs';
import { UsersAMClient } from '../../api/api-access-management.service.generated';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionsService {
  private usersClient = inject(UsersAMClient);

  private permissions$?: Observable<string[]>;

  getPermissions(): Observable<string[]> {
    if (!this.permissions$) {
      this.permissions$ = this.usersClient.getCurrentUserPermissions().pipe(
        map(permissions => permissions ?? []),
        shareReplay(1)
      );
    }
    return this.permissions$;
  }

  hasPermission(permission: string): Observable<boolean> {
    if (!permission) return of(true);
    return this.getPermissions().pipe(map(permissions => permissions.includes(permission)));
  }

  hasAnyPermission(permissions: string[]): Observable<boolean> {
    if (!permissions?.length) return of(true);
    return this.getPermissions().pipe(
      map(userPermissions => permissions.some(p => userPermissions.includes(p)))
    );
  }
}
